<nz-modal
    [(nzVisible)]="isVisible"
    [nzMaskClosable]="false"
    [nzTitle]="(isImport ? 'Select' : 'Export') + ' Resource'"
    [nzOkLoading]="submitLoading || loading"
    nzWidth="750px"
    [nzOkText]="isImport ? 'Import' : 'Export'"
    (nzOnCancel)="close()"
    (nzOnOk)="isImport ? getImportType() : submit()"
>
    <ng-container *nzModalContent>
        <nz-spin [nzSpinning]="loading">
            <div class="menu-container">
                <div class="search" *ngIf="!isImport">
                    <app-multiple-input-search
                        style="width: 200px"
                        #inputTag
                        (searchTag)="onSearch()"
                    ></app-multiple-input-search>
                    <button class="text-btn-primary button" nz-button (click)="onSearch()">Search</button>
                </div>
                <div class="menu-box">
                    <div *ngIf="!keywordList || keywordList.length === 0">
                        <app-resource-select [menus]="menus"></app-resource-select>
                    </div>

                    <div *ngIf="keywordList && keywordList.length > 0">
                        <nz-collapse *ngIf="menus?.length > 0;else empty">
                            <nz-collapse-panel
                                *ngFor="let menu of menus; let i = index"
                                [nzHeader]="menu.category"
                                [nzActive]="menu.active"
                                class="category-panel"
                            >
                                <nz-collapse>
                                    <ng-container *ngFor="let child of menu.children;">
                                        <nz-collapse-panel
                                            *ngIf="child.tableData && child.tableData.length > 0"
                                            [nzActive]="child.active"
                                            [nzHeader]="child.tab"
                                            class="resource-panel"
                                        >
                                            <div class="resource-table-container">
                                                <ng-container *ngIf="child.tableData && child.tableData.length > 0">
                                                    <app-st #st
                                                            [columns]="columns"
                                                            [data]="child.tableData"
                                                            [canSelect]="true"
                                                            [selectType]="'multiple'"
                                                            size="small"
                                                            [templates]="{keyword: keyword}"
                                                            (selectChange)="handleSelect($event, child)"
                                                    >
                                                        <ng-template #keyword let-row>
                                                            <app-status-tag *ngFor="let item of row.keywordList;" [tagColor]="'blue'"
                                                                            [status]="item"></app-status-tag>
                                                        </ng-template>
                                                        <ng-template #keyword>
                                                        </ng-template>
                                                    </app-st>
                                                </ng-container>
                                            </div>
                                        </nz-collapse-panel>
                                    </ng-container>
                                </nz-collapse>
                            </nz-collapse-panel>
                        </nz-collapse>
                        <ng-template #empty>
                            <nz-empty nzNotFoundImage="simple"></nz-empty>
                        </ng-template>
                    </div>
                </div>
            </div>
        </nz-spin>
    </ng-container>
</nz-modal>
